export enum LIST_TYPE {
    ordered = 'ordered',
    unordered = 'unordered',
}
